// Shared "which tab does this invite belong to" logic for both the instructor's student
// invites (Enroll.tsx) and the school admin's instructor invites (Instructors.tsx).
// "Expired" is never a value either invitations table actually stores in its status column
// (both tables' accept RPCs reject on expires_at < now() and return {ok:false,
// code:'expired'} without ever writing a row) — it is always this client-computed
// condition over a still-'pending' row, exactly mirroring how each accept RPC itself
// decides the same thing server-side at acceptance time.
export type InviteTabKey = 'pending' | 'accepted' | 'expired' | 'revoked'

export function effectiveInviteStatus(status: string, expiresAt: string): InviteTabKey {
  if (status === 'pending' && new Date(expiresAt) < new Date()) return 'expired'
  return (status as InviteTabKey) ?? 'pending'
}

export const INVITE_TABS: { key: InviteTabKey; label: string }[] = [
  { key: 'pending',  label: 'Sent' },
  { key: 'accepted', label: 'Accepted' },
  { key: 'expired',  label: 'Expired' },
  { key: 'revoked',  label: 'Revoked' },
]
